module.exports = __webpack_public_path__ + "static/img/esp.3c199a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/esp.svg
// module id = j9ke
// module chunks = 0